// extracted by css-extract-rspack-plugin
export default {"navigationList":"_c97faf53","linkWrapper":"_e685d408","link":"_5a7cb41b","activeLink":"_c9166e17"};